import React, { useState } from 'react';
import { Upload, message, Button, Col } from 'antd';
import upload from '../../../../../assets/upload.svg';
// import { getRequiredEnv } from '@sebbia/dynamic-env';
import { UploadChangeParam } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';
import { extensionToFileType } from '../../../../../../../../utils/helpers';
import { useTranslation } from 'react-i18next';

export default function SingleFileUpload(props: {
  title: string;
  onChange?: (fileId?: string) => void;
  initialValue?: string;
  imageUpload?: boolean;
  accept: string[];
  maxFileSize: number;
}) {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  function handleUpload(info: UploadChangeParam) {
    switch (info.file.status) {
      case 'error': {
        break;
      }
      case 'done': {
        const fileList = info.fileList.map((file) => {
          if (file.response) {
            const id: string = file.response.fileIds[0];
            if (props.onChange) props.onChange(id);
          }
          return file;
        });
        setFileList(fileList);
        break;
      }
      case 'removed': {
        setFileList([]);
        if (props.onChange) props.onChange(undefined);
        break;
      }
      default: {
        setFileList(info.fileList);
        break;
      }
    }
  }

  function beforeUpload(file: UploadFile, fileList: UploadFile[]): boolean {
    function generateError(msg: string) {
      message.error(msg);
      setFileList(
        fileList.map((file) => {
          file.status = 'error';
          return file;
        })
      );
    }

    const supportedFyleTypes = props.accept.map((e) => extensionToFileType(e));
    if (!supportedFyleTypes.includes(file.type)) {
      generateError(`${t('modules.single_file_upload.generate_error.0')} ${props.accept.join(' ')}`);
      return false;
    }
    const tooBig = file.size! / 1024 / 1024 > props.maxFileSize;
    if (tooBig) {
      generateError(`${t('modules.single_file_upload.generate_error.1')} ${props.maxFileSize}MB`);
      return false;
    }

    return true;
  }

  return (
    <Col lg={props.imageUpload ? 24 : 11} sm={24} xs={24}>
      <Upload
        action={window.parametrize('REACT_APP_FILE_STORAGE')}
        onChange={handleUpload}
        fileList={fileList}
        beforeUpload={beforeUpload}
        accept={props.accept.join(', ')}
      >
        {fileList.length >= 1 ? null : (
          <Button id="SingleFileUploadButton">
            <img style={{ width: 20, marginRight: 10 }} src={upload} alt={t('modules.single_file_upload.img')!} />
            {props.title}
          </Button>
        )}
      </Upload>
    </Col>
  );
}
